import { differenceInYears, parse } from 'date-fns';

export const yearsFromDateToNow = (date: string) => {
    const date1 = parse(date, 'dd/MM/yyyy', new Date());
    const age = differenceInYears(new Date(), date1);
    return age;
};
